export default {
    initLotsCardLikes() {
        $('.product-card--favorite').on('click',function(){
            const $this = $(this);
            const productId = $this.data('id');

            $.ajax({
                url: `/favorite/${productId}`,
                method: 'POST',
                data: {
                },
                success: function (isFavorite) {
                        if (isFavorite) {
                            $this.addClass('active');
                        } else {
                            $this.removeClass('active');
                        }
                },
                error: function (xhr) {
                }
            });
        })
    },

    initAuctionCardLikes() {
        $('.auction-card--info-liked').on('click', function(){
            $(this).toggleClass('active');
        })
    },

    initAuctionLike() {
        $('.about-auction--info-liked').on('click', function(){
            $(this).toggleClass('active');
        })
    },

    auctionCardSlideDownMore(){
        $('.product-card--about-extra-btn').on('click', function(e){
            e.preventDefault();
            let parent =  $(this).closest('.product-card--about');
            $('.product-card--about').removeClass('active');
            $('.product-card--about-extra-wrap').slideUp(300)
            if(parent.hasClass('active')){
                parent.removeClass('active');
                parent.find('.product-card--about-extra-wrap').slideUp(300)
            } else {
                parent.addClass('active');
                parent.find('.product-card--about-extra-wrap').slideDown(300)
            }
        })
    },
}